import fontawesome from '@fortawesome/fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

fontawesome.library.add(faEye, faEyeSlash, faExclamationCircle);
